module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon-progress-done.4fbacb9f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon-progress-done.png
// module id = 2992
// module chunks = 11